import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Alert from '@mui/material/Alert'
import Typography from '@mui/material/Typography'

import { installInstructions } from '../../services/installInstructions'

/**
 * The manual route to the home screen, for every browser that will not let the
 * app ask (#330).
 *
 * Shown when the side menu's install entry is used and there is no
 * `beforeinstallprompt` to fire — on iOS that is always, which is why an iPhone
 * user previously saw nothing about installing anywhere in the product.
 */
export default function InstallInstructionsDialog({ open, onClose, environment }) {
  const { title, steps, note } = installInstructions(
    environment ?? {
      userAgent: navigator.userAgent,
      maxTouchPoints: navigator.maxTouchPoints,
    }
  )

  return (
    <Dialog open={open} onClose={onClose} dir="rtl">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography component="ol" sx={{ pr: 2, m: 0 }}>
          {steps.map((step) => (
            <Typography component="li" key={step} sx={{ mb: 1 }}>
              {step}
            </Typography>
          ))}
        </Typography>
        {note && (
          <Alert severity="info" sx={{ mt: 2 }}>
            {note}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          הבנתי
        </Button>
      </DialogActions>
    </Dialog>
  )
}
